import { publicFetch } from "api/publicFetch";

/**
 * @typedef {
 * {
 *  "courseId": number;
 *  "courseName": string;
 *  "duration": string;
 *  "language": string;
 *  "difficultyLevel": string;
 *  "certificate": number;
 *  "mrp": string;
 *  "sellingPrice": string;
 *  "totalSessionCount": number;
 * }
 * } Response
 */

/**
 * Get courses
 * @param {string} name Search term
 * @param {import('axios').CancelTokenSource} cancelToken Cancel Token
 * @returns {Promise<Response[]>} Response
 */
const searchCourses = async (name, cancelToken) => {
  const { data } = await publicFetch.get(`/searchcourses/coursename=${name}`, {
    cancelToken: cancelToken?.token,
  });
  return data;
};

export default searchCourses;
